import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const expenses = createReducer({}, (builder) => {
  builder
    .addMatcher(
      (action) =>
        [
          actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS,
          actionTypes.FETCH_EXPENSES_SUCCESS,
          actionTypes.UPDATED_EXPENSES,
          actionTypes.FETCH_FILES_AND_ATTACHMENTS_SUCCESS,
          actionTypes.BATCH_EDIT_EXPENSES_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { expenses = {} } = entities;
        return { ...state, ...expenses };
      }
    )
    .addMatcher(
      (action) =>
        [
          actionTypes.FETCH_EXPENSE_SUCCESS,
          actionTypes.ADD_EXPENSE_SUCCESS,
          actionTypes.EDIT_EXPENSE_SUCCESS,
          actionTypes.EXPENSE_CREATED_FROM_EVENT_STREAM,
          actionTypes.EXPENSE_UPDATED_FROM_EVENT_STREAM,
          actionTypes.EXPENSE_MOVED_TO_PROJECT_FROM_EVENT_STREAM,
          actionTypes.MOVE_EXPENSE_TO_TRASH_SUCCESS,
          actionTypes.EXPENSE_MOVE_TO_TRASH_FROM_EVENT_STREAM,
          actionTypes.EXPENSE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM,
          actionTypes.MOVE_EXPENSE_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { result = {}, entities = {} } = response;
        const { single: id } = result;
        const { expenses = {} } = entities;

        return { ...state, [id]: expenses[id] || {} };
      }
    )
    .addMatcher(
      (action) => [actionTypes.FETCH_PROJECT_EXPENSES_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = {}, cursor } = action;
        const { entities = {} } = response;
        const { expenses = {} } = entities;
        return cursor ? { ...state, ...expenses } : { ...expenses };
      }
    );
});

export default expenses;
